import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum DutyPermissionSet {
  View = 'duty_view',
  New = 'duty_new',
  Edit = 'duty_edit',
  Delete = 'duty_delete',
  Cancel = 'duty_cancel',
  Import = 'duty_import',
  Export = 'duty_export',
  InitiateTriggeredOptimization = 'duty_initiate_triggered_optimization',

  CompleteSlot = 'duty_complete_slot',
  ViewVehicleLocation = 'duty_view_vehicle_location',
  StartDriverConversation = 'duty_start_driver_conversation',
  ViewDriverConversation = 'duty_view_driver_conversation',
}

// Ignore prettier to ensure only one permission per line
// prettier-ignore
export const dutyPermissionSetGrouping: IPermissionSetGrouping<DutyPermissionSet> = {
  key: PermissionSetGroupingKey.Duty,
  active: {
    [DutyPermissionSet.View]: [
      PermissionType.GET_ANY_DUTY,
      PermissionType.LIST_ANY_DUTY,
      PermissionType.LIST_ANY_SLOT,
      PermissionType.GET_ANY_SLOT,
      PermissionType.LIST_ANY_CUSTOM_FIELD,
      PermissionType.GET_ANY_FILE,
      PermissionType.LIST_ANY_ROUTE_ASSIGNMENT,
      PermissionType.LIST_ANY_ROUTE_ASSIGNMENT_STATE,
      PermissionType.GET_ANY_DRIVER_BREAK, // TODO: remove me once Role updates have completed on prod 
      PermissionType.GET_ANY_DRIVER_BREAK_REASON, // TODO: remove me once Role updates have completed on prod 
    ],
    [DutyPermissionSet.New]: [
      PermissionType.POST_ANY_DUTY,
      PermissionType.POST_ANY_MULTIPLE_DUTIES,
    ],
    [DutyPermissionSet.Edit]: [
      PermissionType.PATCH_ANY_DUTY,
      PermissionType.POST_ANY_ROUTE_ASSIGNMENT,
      PermissionType.DELETE_ANY_ROUTE_ASSIGNMENT,
      PermissionType.WRITE_ANY_DRIVER_BREAK, // TODO: remove me once Role updates have completed on prod 
      PermissionType.CANCEL_ANY_DRIVER_BREAK, // TODO: remove me once Role updates have completed on prod 
      PermissionType.POST_ANY_DRIVER_BREAK_REASON, // TODO: remove me once Role updates have completed on prod 
      PermissionType.PATCH_ANY_DRIVER_BREAK_REASON, // TODO: remove me once Role updates have completed on prod 
      PermissionType.DELETE_ANY_DRIVER_BREAK_REASON, // TODO: remove me once Role updates have completed on prod 
    ],
    [DutyPermissionSet.Cancel]: [
      PermissionType.CANCEL_ANY_DUTY,
      PermissionType.CANCEL_ANY_MULTIPLE_DUTIES,
    ],
    [DutyPermissionSet.Delete]: [
      PermissionType.DELETE_ANY_DUTY,
      PermissionType.DELETE_ANY_MULTIPLE_DUTIES,
    ],
    [DutyPermissionSet.Import]: [
      PermissionType.IMPORT_ANY_DUTY,
    ],
    [DutyPermissionSet.Export]: [
      PermissionType.EXPORT_ANY_DUTY,
    ],
    [DutyPermissionSet.InitiateTriggeredOptimization]: [
      PermissionType.POST_ANY_TRIGGERED_OPTIMIZATION,
    ],
    [DutyPermissionSet.ViewVehicleLocation]: [
      PermissionType.GET_ANY_VL,
      PermissionType.GET_ANY_LAST_DUTY_VL,
    ],
    [DutyPermissionSet.CompleteSlot]: [
      PermissionType.COMPLETE_ANY_SLOT,
    ],
    [DutyPermissionSet.StartDriverConversation]: [
      PermissionType.POST_DISPATCHER_COMMS_ACCESS_TOKEN, // Start conversation
    ],
    [DutyPermissionSet.ViewDriverConversation]: [
      PermissionType.GET_ANY_DUTY_CONVERSATION, // View conversation messages
    ],
  },
  unAssignablePermissionSets: [],
}
